export const colors = {
    primary: 'rgba(0, 155, 235, 1)',
    secondary: '', 
    colorSider: 'rgba(0, 67, 123, 1)',
}